import React, { useEffect } from 'react';
import Layout from '@shared/ui/organisms/layout/Layout';
import { HeadlineLarge } from '@shared/ui/atoms/fonts/Headline';
import { useTranslation } from "react-i18next";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import styled from "styled-components";
import { FilterBar } from "./components/FilterBar";
import { HolidayAllowanceUserList } from "./components/HolidayAllowanceUserList";
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { useDispatch, useSelector } from "react-redux";
import {
  loadUsersAllowances,
  selectGroupSelection,
  selectHolidayAllowances,
  selectIsLoading,
  selectPaginationInfo
} from "../models/holiday-allowances.duck";
import { Center, Row } from '@shared/ui/atoms/StructuralLayout';
import { LoadingSpinner } from '@shared/ui/atoms/LoadingSpinner';
import { HolidayAllowanceSaveBar } from "./components/HolidayAllowanceSaveBar";
import { HolidayAllowanceHeaderRow } from "./components/HolidayAllowanceHeaderRow";
import { deleteQueryParam, getParameterByName } from '@shared/utils/UrlUtils';
import { selectConfig } from '@shared/store/config.duck';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';

export function HolidayAllowanceSettings(props: Props) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const paginationInfo = useSelector(selectPaginationInfo);
  const groupSelection = useSelector(selectGroupSelection)
  const holidayAllowances = useSelector(selectHolidayAllowances)
  const config = useSelector(selectConfig);
  const isLoading = useSelector(selectIsLoading);

  const onGroupSelectionChange = (selection: string) => {
    deleteQueryParam('userId')
    dispatch(loadUsersAllowances({groupSelection: selection, skip: 0}))
  }

  const changePage = (shift: number) => {
    dispatch(loadUsersAllowances({groupSelection: groupSelection, skip: paginationInfo.skip + shift}))
  }

  useEffect(() => {
    const userId = getParameterByName('userId', window.location.href);
    if (userId) {
      dispatch(loadUsersAllowances({groupSelection: userId, isUser: true, skip: 0}))
    }
  }, [dispatch]);

  return (
    <>
      <Layout>
        <HeaderRow>
          <HeadlineLarge>{t('allowance.title')}</HeadlineLarge>
          <Row>
            {config.autoCarryOverEnabled && <PrimaryButton style={{marginRight: 12}}
                                                           link={window.location.href.includes('/manage/holidays/') ? `/manage/holidays/settings/allowance-carry-over-preview` : `/holidays/settings/allowance-carry-over-preview`}
                                                           text={'allowance.go-to-rollover-management'}/>}
            <OutlineButton link={'/manage/holidays'} icon={IconTypes.Settings} text={'settings-page.holiday'} />
          </Row>
        </HeaderRow>

        <HolidayAllowanceHeaderRow />

        <FilterBar onGroupSelected={selection => onGroupSelectionChange(selection)} />

        <HolidayAllowanceUserList allowances={holidayAllowances} />

        {isLoading ? <>
          <Center>
            <LoadingSpinner style={{marginTop: 50}}
                            hideText={true}
                            fullScreen={false}
                            hideBorder={true} />
          </Center>
        </> : <>
          {paginationInfo.totalRecords > paginationInfo.count && <FooterRow>
            <OutlineButton text={"Previous"} click={() => changePage(-1 * paginationInfo.count)} />
            <BodyRegular>Showing {paginationInfo.skip} to {paginationInfo.count + paginationInfo.skip} of {paginationInfo.totalRecords}</BodyRegular>
            <OutlineButton text={"Next"} click={() => changePage(paginationInfo.count)} />
          </FooterRow>}
        </>}


      </Layout>
      <HolidayAllowanceSaveBar />
    </>
  )
}

interface Props {
}

const HeaderRow = styled.div`
  margin: 32px 0 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .linkButton {
    margin: 0;
    width: unset;
    max-width: unset;
  }
`

const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
`
